import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardHeader, CardContent, Stack, Typography, Checkbox } from '@mui/material';

import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import { DynamicMultiFieldCard } from '../ReservationDataTab/DynamicMultiFieldCard';

export const ParticipantsForm = props => {
  const { formik } = props;
  const { seasonIdentifier, seasonYear } = useSelector(state => state.app);

  return (
    <Card>
      <CardHeader title="Dane uczestników" sx={{ mt: -1 }} />
      <CardContent>
        <Box display="flex" flexDirection="row" justifyContent="center" m={2} p={1} flexWrap="wrap">
          <Stack direction="column">
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2">Liczba chłopców</Typography>
              <SmallFormTextField
                error={formik.errors.boys_count && formik.touched.boys_count}
                name="boys_count"
                placeholder="liczba chłopców"
                value={formik.values.boys_count}
                onChange={formik.handleChange}
                helperText={formik.errors.boys_count}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2">Liczba dziewczynek</Typography>
              <SmallFormTextField
                error={formik.errors.girls_count && formik.touched.girls_count}
                name="girls_count"
                placeholder="liczba dziewczynek"
                value={formik.values.girls_count}
                onChange={formik.handleChange}
                helperText={formik.errors.girls_count}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2">Liczba uczestników</Typography>
              <SmallFormTextField
                value={Number(formik.values.girls_count) + Number(formik.values.boys_count)}
                disabled={true}
              />
            </Stack>
            { seasonYear < 2027 ? <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2">Wiek uczestników</Typography>
              <SmallFormTextField
                error={formik.errors.participants_age && formik.touched.participants_age}
                name="participants_age"
                placeholder="wiek uczestników"
                value={formik.values.participants_age}
                onChange={formik.handleChange}
                helperText={formik.errors.participants_age}
              />
            </Stack> : <DynamicMultiFieldCard
              formik={formik}
              title="Wiek uczestników"
              fields={[
                {
                  label: '',
                  field: 'participants_age_json',
                  keyName: 'Wiek',
                  secondKeyName: 'Ilość osób'

                }
              ]}
            />}
          </Stack>
          <Stack direction="column">
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2" sx={{ flex: '0 0 50%' }}>Informacja nt. chorób dzieci, dysfunkcji, diet, uczuleń itp.</Typography>
              <SmallFormTextField
                sx={{ flex: '0 0 50%' }}
                multiline
                rows={3}
                error={formik.errors.additional_participants_info && formik.touched.additional_participants_info}
                name="additional_participants_info"
                value={formik.values.additional_participants_info}
                onChange={formik.handleChange}
                helperText={formik.errors.additional_participants_info}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2" sx={{ flex: '0 0 50%' }}>​Dodatkowe informacje na temat ilości klas i ilość osób w nich</Typography>
              <SmallFormTextField
                sx={{ flex: '0 0 50%' }}
                multiline
                rows={3}
                error={formik.errors.additional_participants_class_info && formik.touched.additional_participants_class_info}
                name="additional_participants_class_info"
                value={formik.values.additional_participants_class_info}
                onChange={formik.handleChange}
                helperText={formik.errors.additional_participants_class_info}
              />
            </Stack>
            {['l_24_zs', 'l_25_zs'].includes(seasonIdentifier) ? <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} p={2}>
              <Typography variant="subtitle2" sx={{ flex: '0 0 50%' }}>Dieta specjalna</Typography>
              <Checkbox
                sx={{ flex: '0 0 50%' }}
                id="zs_special_diet"
                name="zs_special_diet"
                checked={formik.values.zs_special_diet}
                onChange={formik.handleChange}/>
            </Stack> : null}
            {['l_24_zs', 'l_25_zs'].includes(seasonIdentifier) ? <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} p={2}>
              <Typography variant="subtitle2" sx={{ flex: '0 0 50%' }}>Dieta specjalna informacje</Typography>
              <SmallFormTextField
                sx={{ flex: '0 0 50%' }}
                multiline
                rows={3}
                error={formik.errors.zs_special_diet_info && formik.touched.zs_special_diet_info}
                name="zs_special_diet_info"
                value={formik.values.zs_special_diet_info}
                onChange={formik.handleChange}
                helperText={formik.errors.zs_special_diet_info}
              />
            </Stack>
              : null}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};
